import { ModalContext } from 'app/app';
import axios from 'axios';
import { ViewContext } from 'components/lib';
import { useState, useEffect, useContext, Fragment } from 'react';

export default function EndorsementStatusModal() {
  const { modal, setModal } = useContext(ModalContext);
  const context = useContext(ViewContext);

  const [currentStatus, setCurrentStatus] = useState('');
  const [selectedStatus, setSelectedStatus] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const statusOptions = [
    { value: 'active', label: 'Active' },
    { value: 'bound', label: 'Bound' },
    { value: 'declined', label: 'Declined' },
    { value: 'not_taken_up', label: 'Not Taken Up' },
    { value: 'permanently_delete_ticket', label: 'Permanently Delete Ticket' }
  ];

  useEffect(() => {
    if (modal.name === 'endorsement_status_modal' && modal.data) {
      setCurrentStatus(modal.data.status || 'active');
      setSelectedStatus(modal.data.status || 'active');
    }
  }, [modal.name, modal.data]);

  const handleStatusChange = (e) => {
    setSelectedStatus(e.target.value);
  };

  const handleSaveClick = async () => {
    if (!modal.data || !modal.data.id) {
      context.notification.show(
        'Missing endorsement ID',
        'error',
        true,
        'toast',
        'x-circle'
      );
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await axios.put(`/api/endorsement/${modal.data.id}`, {
        status: selectedStatus
      });

      if (response.status !== 200) {
        throw new Error('Failed to update endorsement status');
      }

      context.notification.show(
        'Status updated successfully!',
        'success',
        true,
        'toast',
        'check-circle'
      );

      setModal('');

      if (modal.data.onUpdate && typeof modal.data.onUpdate === 'function') {
        modal.data.onUpdate();
      }
    } catch (error) {
      context.notification.show(
        'There was a problem updating the status.',
        'error',
        true,
        'toast',
        'x-circle'
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Fragment>
      {modal.name === 'endorsement_status_modal' && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-[102] flex items-center justify-center">
          <div className="w-full max-w-[500px] bg-white flex items-center justify-center rounded-[12px]">
            <div className="w-[90%] mt-[20px] mb-[2px]">
              <div className="mb-4 w-full mx-auto bg-white max-w-screen-xl">
                <div className="mt-4 pt-0">
                  <h2 className="text-xl font-semibold mb-4">Update Endorsement Status</h2>

                  <div className="mb-2">
                    <label htmlFor="status-select" className="block mb-2">Select new status:</label>
                    <select
                      id="status-select"
                      value={selectedStatus}
                      onChange={handleStatusChange}
                      className="w-full p-3 border border-gray-300 rounded-md"
                    >
                      {statusOptions.map(option => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>

                    {selectedStatus === 'bound' && (
                      <p
                        className="
                        mt-3 text-amber-600 bg-amber-50 p-3
                        text-sm rounded-md border border-amber-200
                        "
                      >
                        <strong>Warning:</strong>
                        Setting status to "Bound" will lock the endorsement from further editing.
                        All fields and message functionality will be disabled.
                      </p>
                    )}

                    {selectedStatus === 'permanently_delete_ticket' && (
                      <p
                        className="
                          mt-3 text-red-600 bg-red-50 p-3
                          text-sm rounded-md border border-red-200
                        "
                      >
                        <strong>Warning:</strong>
                        This action will lock the ticket from further editing and move it to the delete Tab.
                        This action cannot be undone.
                      </p>
                    )}
                  </div>
                </div>

                <div className="mt-4 pt-0">
                  <div className="w-full flex items-center justify-end">
                    <button
                      className="
                        h-12 px-4 bg-white border border-gray-400
                        font-semibold rounded-md cursor-pointer
                      "
                      onClick={() => setModal('')}
                    >
                      Cancel
                    </button>
                    <button
                      className="
                        h-12 ml-2 px-4 bg-[#d32425] font-semibold
                        rounded-md cursor-pointer text-white
                        disabled:bg-gray-200 disabled:cursor-not-allowed
                      "
                      onClick={handleSaveClick}
                      disabled={isSubmitting || currentStatus === selectedStatus}
                    >
                      {isSubmitting ? 'Saving...' : 'Save'}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
}
